/**
   *  Loại phương án phân bổ
   */
export default {
  DeliverBeginYear: 1, //Giao đầu năm
  DeliverAdditional: 2, //Giao bổ sung
  DeliverAdjustment: 3, //Giao điều chỉnh
  DeliverAdditionalAdjustment: 5 // Giao bổ sung, điều chỉnh
};